import React, {Component} from "react";
import {QRCode} from "react-qrcode-logo";
import {connect} from "react-redux";
import loading from "../../../../assets/img/loading.svg";

import fonepay from "../../../../assets/img/payment/Fonepay.png";
import qrsuccess from "../../../../assets/img/payment/qrsuccess.svg";
import scan from "../../../../assets/img/payment/scan.svg";
import {CheckoutCurrentCart, OtherPayment, UpdatePayment,} from "../../../../redux/actions/Cart.Action";

import ApiConnect from "../../../../Utils/ApiConnect";

class Fonepay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrMessage: null,
      qrImage: scan,
      statusMessage: "",
      showCheckout: false,
    };

    this.socket = null;
  }

  componentDidMount() {
    const { order_id, CurrentCart, UpdatePayment } = this.props;

    this.fetchFonePayQR(order_id);
    UpdatePayment("Fonepay", CurrentCart.total, "");
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
    }
  }


  fetchFonePayQR(orderId) {
    ApiConnect.get(`POS/Checkout/FonepayQR?orderid=${orderId}`)
      .then((res) => {
        const data = res.data;

        if (data.status === 201) {
          if (data.socket) {
            this.initWebSocket(data.socket);
          }

          this.setState({ qrMessage: data.qrMessage });
        }

        if (data.status === 202) {
          this.setState({
            qrMessage: "",
            qrImage: qrsuccess,
            statusMessage: "",
          });
        }
      })
      .catch(console.error);
  }


  initWebSocket = (url) => {
    this.socket = new WebSocket(url);

    this.socket.onerror = (err) => console.error("WebSocket Error:", err);

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const status = JSON.parse(data.transactionStatus);

      if (status.paymentSuccess) {
        this.handlePaymentSuccess(status);
      }

      if (status.qrVerified) {
        this.setState({ qrImage: loading, qrMessage: "" });
      }
    };
  };


  handlePaymentSuccess(status) {
    const { OtherPayment, fallBack, autoCheckout, CheckoutCurrentCart } =
      this.props;

    this.setState({
      qrImage: qrsuccess,
      qrMessage: "",
      statusMessage: `Received ${status.totalCalculatedAmount}`,
      showCheckout: true,
    });

    OtherPayment("Fonepay", status.totalCalculatedAmount, status.traceId);
    this.confirmPayment("Fonepay", status.totalCalculatedAmount, status.traceId);

    if (fallBack) fallBack();

    if (autoCheckout) {
      setTimeout(() => CheckoutCurrentCart("", ""), 8000);
    }
  }


  confirmPayment(type, amount, tid) {
    ApiConnect.put(
      `POS/Checkout/PaymentDone?orderid=${this.props.order_id}&type=${type}&amount=${amount}&tid=${tid}`
    ).catch(console.error);
  }


  render() {
    const { autoCheckout } = this.props;
    const { qrMessage, qrImage, statusMessage, showCheckout } = this.state;

    return (
      <>
        <div className="container text-center">
          <h6>{statusMessage}</h6>

          <figure className="figure img-thumbnail">
            {qrMessage ? (
              <QRCode
                value={qrMessage}
                size={250}
                qrStyle="dots"
                logoHeight={50}
                eyeRadius={50}
              />
            ) : (
              <img src={qrImage} width="250" alt="default" />
            )}

            <figcaption className="figure-caption text-center">
              <img src={fonepay} width="60" alt="FonePay Logo" />
            </figcaption>
          </figure>
        </div>

        {autoCheckout && showCheckout && (
          <button
            className="btn btn-primary w-100"
            onClick={() => this.props.CheckoutCurrentCart("", "")}
          >
            Checkout
          </button>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ CurrentCart: state.Cart.CurrentCart }),
  { UpdatePayment, OtherPayment, CheckoutCurrentCart }
)(Fonepay);
